import axiosInstance from './axiosCreator';

export interface TestimonialInterestPayload {
  rating: number;
  comment?: string;
}

/** Submits a student's testimonial interest for ORA-771. */
export const submitTestimonialInterest = async (
  payload: TestimonialInterestPayload
): Promise<void> => {
  await axiosInstance.post('/feedback/testimonial-interest', payload);
};
